import { Button } from '@cimplico/components';
import Dropzone from '../dropzone/Dropzone';
import { ReactComponent as UploadIcon } from '../../assets/upload.svg';
import { createCsvFile } from '../../utilities/csv-file';
import { useRef } from 'react';
import FileInput from '../../features/files/FileInput';

type UploadFileProps = {
    columns: string[];
    fileName: string;
    onUpload: (files: File[]) => void;
};

function TemplateUploadDropzone({ columns, fileName, onUpload }: UploadFileProps): JSX.Element {
    const uploadRef = useRef<HTMLInputElement | null>(null);

    function handleDownload(): void {
        createCsvFile(columns, fileName);
    }

    function openFileInput(): void {
        if (uploadRef.current) {
            uploadRef.current.click();
        }
    }

    return (
        <div>
            <FileInput innerRef={uploadRef} onSelect={onUpload} />
            <div>
                <div className="flex justify-center">
                    <Button type="primary" label="Download Template" onClick={handleDownload} />
                </div>
                <p className="flex justify-center text-gray-500 mt-2 text-sm">then</p>
                <Dropzone onDrop={onUpload}>
                    <div
                        className="flex flex-col items-center mt-2 border-dashed border border-gray-300 rounded-md p-4 cursor-pointer"
                        onClick={openFileInput}
                    >
                        <UploadIcon />
                        <p className="mt-2 text-sm">Upload filled-in template (.csv)</p>
                    </div>
                </Dropzone>
            </div>
        </div>
    );
}

export default TemplateUploadDropzone;
